async function quickBagXAPI(bagGuid = '') {
  try {
    const url = `/xapi/bag/v1/quickbag/${bagGuid}`;
    const respons = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    if (respons.status === 200) {
      return respons.json();
    }
    return {};
  } catch (error) {
    throw new Error();
  }
}

/* eslint-disable */
export {
  quickBagXAPI,
};
/* eslint-enable */
